import React from 'react';
import './TransactionDetails.scss';
import transactionData from './transactionData.json'; // Importing the JSON data
import ProgressSteps from '../Progres/ProgressSteps';
import { BsCopy } from "react-icons/bs";
import { IoCheckmarkOutline } from "react-icons/io5";

const TransactionDetails = () => {
  // Using the imported data directly
  const { title, status, orderNumber, transactionTime } = transactionData.transactionDetails;

  return (
    <>
      <ProgressSteps completed={2} />
      <div className='f'>
        <div className="transaction-details">
          <div className="header">
            <h1 className="title">{title}</h1>
            <span className="status">{status}</span>
          </div>
          <hr />
          <div className="content">
            <div className="order-number">
              <span className="label">{orderNumber.label}</span>
              <span className="value">{orderNumber.value} <BsCopy /></span>
            </div>
            <hr />
            <div className="transaction-time">
              <span className="label">{transactionTime.label}</span>
              <span className="value">{transactionTime.value}</span>
            </div>        
          </div>          
        </div>
      </div> 
      <div className="confirmation">
            <IoCheckmarkOutline className="checkmark-icon" />
            <span className="confirmation-text">Confirm read</span>
          </div>   
    </>
  );
};

export default TransactionDetails;
